import { Box, Chip, Typography } from '@mui/material';
import { ReactNode } from 'react';

import zeplinColor from 'theme/Color';
import { Utilities } from 'utilities/utilities';
import { Variant } from './type';

const Card = ({ variant = 'big', val }: { variant?: Variant; val: any }) => {
  return <>{renderContent[variant](val)}</>;
};

const renderContent: Record<Variant, (data: any) => ReactNode> = {
  small: (data) => (
    <Box
      sx={{
        display: 'flex',
        padding: '16px',
        gap: '12px',
        borderRadius: '14px',
        border: `1px solid ${zeplinColor.Neutral5}`,
      }}
    >
      {data?.imageUrl ? (
        <img
          src={'/assets/no-news.svg'}
          alt='zoominfo-no-news'
          style={{
            borderRadius: '8px',
            width: '64px',
            height: '64px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: zeplinColor.Neutral3,
          }}
        />
      ) : (
        <img
          src={data?.imageUrl}
          width='100%'
          height='140px'
          alt='zoominfo-news'
          style={{
            borderRadius: '8px',
            width: '64px',
            height: '64px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: zeplinColor.Neutral3,
          }}
        />
      )}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          gap: '8px',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          {data?.categories?.map((item: any) => (
            <Chip
              key={item}
              label={
                <Typography
                  variant='responsiveLabel1'
                  sx={{ display: 'flex', alignItems: 'center' }}
                  color={zeplinColor.BasicBlack}
                >
                  {Utilities.formatSnakeToTitle(item)}
                </Typography>
              }
              sx={{
                backgroundColor: zeplinColor.Neutral4,
                color: zeplinColor.Neutral1,
                '&.MuiChip-root': {
                  height: '24px',
                  padding: '5px 12px',
                  borderRadius: '50px',
                },
                '& .MuiChip-label': {
                  padding: 0,
                },
              }}
            />
          ))}

          <Typography variant='responsiveLabel1' color={zeplinColor.Neutral8}>
            {Utilities.formatDate(data?.pageDate)}
          </Typography>
        </Box>

        <Typography
          sx={{
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            fontSize: '14px',
          }}
        >
          {data?.title}
        </Typography>
      </Box>
    </Box>
  ),
  big: (data) => (
    <Box
      sx={{
        borderRadius: '14px',
        border: `1px solid ${zeplinColor.Neutral5}`,
        display: 'flex',
        gap: '8px',
        flexDirection: 'column',
        padding: '16px',
      }}
    >
      {data?.imageUrl ? (
        <Box
          sx={{
            borderRadius: '8px',
            height: '140px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: zeplinColor.Neutral3,
          }}
        >
          <img
            src={'/assets/no-news.svg'}
            width='40px'
            height='40px'
            alt='zoominfo-no-news'
            style={{ objectFit: 'contain' }}
          />
        </Box>
      ) : (
        <img
          src={data?.imageUrl}
          width='100%'
          height='140px'
          alt='zoominfo-news'
          style={{ objectFit: 'cover' }}
        />
      )}

      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        {data?.categories?.map((item: any) => (
          <Chip
            key={item}
            label={
              <Typography
                variant='responsiveLabel1'
                sx={{ display: 'flex', alignItems: 'center' }}
                color={zeplinColor.BasicBlack}
              >
                {Utilities.formatSnakeToTitle(item)}
              </Typography>
            }
            sx={{
              backgroundColor: zeplinColor.Neutral4,
              color: zeplinColor.Neutral1,
              '&.MuiChip-root': {
                height: '24px',
                padding: '5px 12px',
                borderRadius: '50px',
              },
              '& .MuiChip-label': {
                padding: 0,
              },
            }}
          />
        ))}

        <Typography variant='responsiveLabel1' color={zeplinColor.Neutral8}>
          {Utilities.formatDate(data?.pageDate)}
        </Typography>
      </Box>

      <Typography
        sx={{
          fontWeight: 510,
          fontSize: '14px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {data?.title}
      </Typography>

      <Typography
        variant='responsiveBody3'
        color={zeplinColor.Neutral8}
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          wordBreak: 'break-word',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
        }}
      >
        {data?.description}
      </Typography>
    </Box>
  ),
};

export default Card;
